import { UserPermissions } from 'src/utils/permissions';
import { Pagination } from 'src/types/services';

export enum ActionTagUser {
  DELETETAGUSER = 'deleteTagUser',
  ADDUSER = 'addTagUser',
}

export enum KEYS {
  BACKSPACE = 'Backspace',
}

export type TaggedUser = {
  start: number;
  length: number;
  type: {
    user: {
      id: number;
    };
  };
};

export type SegmentationItem = {
  id: number;
  groupId: number;
  name: string;
  position?: number;
  resetAcknowledgmentItem?: boolean;
  usersCount: number;
};

export type Segmentation = {
  id: number;
  name?: string;
  items?: SegmentationItem[];
  item?: SegmentationItem;
};

export type SocialNetworksType = {
  linkedIn?: string | null;
  facebook?: string | null;
  twitter?: string | null;
  instagram?: string | null;
  allowWhatsApp?: true | null;
};

export type User = {
  id: number;
  bossId?: number;
  employeeInternalId: string;
  firstName: string;
  lastName: string;
  fullName?: string;
  isUserBirthday?: boolean;
  isUserAnniversary?: boolean;
  updatedAt: string;
  createdAt: string;
  active: boolean;
  deleted?: boolean;
  hasLeftChat?: boolean;
  profilePicture: string | null;
  points: number | unknown | null;
  email: string | null;
  coverPicture: string;
  phoneNumber: string | null;
  socialNetworks?: SocialNetworksType;
  bio: string | null;
  education: string | null;
  goal: string | null;
  achievements: unknown | null;
  interests: unknown[];
  areas: unknown[];
  languages: unknown[];
  segmentation: Segmentation[];
  hasPasswordChanged: boolean;
  permissions: Record<UserPermissions, boolean>;
  hasDefaultPassword: boolean;
  acknowledgementsToGiveLeft: number;
  language: string;
  hasBeenLogged: boolean;
  color: string;
  isAdmin?: boolean;
  profileData?: any[];
  birthdate?: string;
  hiringDate?: string;
  nickname?: string;
  lastTermsAndConditionsAccepted?: boolean;
  workdays: string[];
  department: string | null;
  isAgent?: boolean;
};

export type UserDictionaryItem = {
  character: string;
  users: User[];
};

// Response
export type UserListResponse = Pagination<User[]>;

export type UserListSegmentationResponse = Pagination<User[]>;

export type SegmentationReachResponse = {
  total: number;
  active: number;
};

// Socket
export type UserDeletedSocket = {
  id: number;
};

// Data
export type SignUpWithInviteData = {
  firstName: string;
  lastName: string;
  inviteCode: string;
  language: string;
  passwordInput: string;
  repeatPasswordInput: string;
  orgName: string;
};

export type JoinWithInviteData = {
  firstName: string;
  lastName: string;
  email: string;
  inviteCode: string;
  language: string;
  passwordInput: string;
  repeatPasswordInput: string;
  employeeInternalId: string;
  orgName: string;
};

export type UserEditableData = {
  phoneNumber: string;
  linkedIn: string;
  instagram: string;
  facebook: string;
  twitter: string;
  firstName: string;
  lastName: string;
  nickname: string;
  profileData: object;
  birthdate: string;
  email: string;
  allowWhatsApp: boolean;
};
